import { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import SchoolInnerPageBanner from "../../components/SchoolInnerPageBanner";
import AdmissionApplicationForm from "../../components/AdmissionApplicationForm";
import useScrollAnimation from "../../constants/useScrollAnimation";
import "./AdmissionsPage.css";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const AdmissionsPage = () => {
  const location = useLocation();
  const { school_slug } = useParams();

  const [loading, setLoading] = useState(true);
  const [criteria, setCriteria] = useState(null);
  const [rows, setRows] = useState([]);


  const [procedure, setProcedure] = useState(null);
  const [lists, setLists] = useState([]);
  const [image, setImage] = useState("");

  const [criteriaHeaderRef, isCriteriaHeaderVisible] = useScrollAnimation(0.2);
  const [criteriaContentRef, isCriteriaContentVisible] = useScrollAnimation(0.2);

  const [procedureHeaderRef, isProcedureHeaderVisible] = useScrollAnimation(0.2);
  const [procedureContentRef, isProcedureContentVisible] = useScrollAnimation(0.2);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const sectionId = location.state?.scrollTo;
    if (!sectionId) return;

    const timer = setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 150);

    return () => clearTimeout(timer);
  }, [location.key]);

  useEffect(() => {
    scrollToTop();
  }, []);

  //  
  useEffect(() => {
    const finalSchoolSlug = school_slug || "tigps-main";

    fetchCriteria();
    fetchProcedure();
  }, [school_slug]);


  /* ---------------- FETCH CRITERIA DATA ---------------- */
  const fetchCriteria = async () => {
    const finalSchoolSlug = school_slug || "tigps-main";
    try {
      const res = await axios.get(
        `${baseAPIUrl}admin/admission_page/get_criteria_section/${finalSchoolSlug}`,
        { withCredentials: true }
      );

      console.log("API RESPONSE:", res.data);

      if (res.data.status === 1) {
        setCriteria(res.data.data.criteria_section);
        setRows(res.data.data.criteria_table);

      }
    } catch (error) {
      console.error("Criteria API error:", error);
    }
  };


  /* ---------------- FETCH APPLICATION PROCEDURE DATA ---------------- */
  const fetchProcedure = async () => {
    const finalSchoolSlug = school_slug || "tigps-main";
    try {
      const res = await axios.get(
        `${baseAPIUrl}admin/admission_page/get_admission_procedure_section/${finalSchoolSlug}`
      );

      console.log("PROCEDURE API FULL RESPONSE:", res.data);

      if (
        res.data.status === 1 &&
        res.data.data &&
        res.data.data.section
      ) {
        setProcedure(res.data.data.section);
        setLists(res.data.data.lists || []);
      } else {
        setProcedure(null);
        setLists([]);
      }
    } catch (err) {
      console.error("Procedure error:", err);
      setProcedure(null);
      setLists([]);
    }
  };



  const groupedLists = lists.reduce((acc, item) => {
    if (!acc[item.title]) {
      acc[item.title] = [];
    }
    acc[item.title].push(item.content);
    return acc;
  }, {});

  // For Criteria
  const hasCriteriaSection =
    criteria &&
    (
      criteria.heading ||
      criteria.description ||
      (Array.isArray(rows) && rows.length > 0) ||
      criteria.note_1 ||
      criteria.note_2
    );


  return (
    <div className="admissions-page">
      <SchoolInnerPageBanner/>

      {/* Criteria Section */}
      {hasCriteriaSection && (
        <div id="criteria" className="admissions-page-criteria-section">
          <div className="admissions-page-container">
            <div ref={criteriaHeaderRef} className={`section-header ${isCriteriaHeaderVisible ? "animate-in" : ""}`}>
              {criteria?.heading && (
                <h2 className="admissions-page-heading section-title-hm">{criteria.heading}</h2>
              )}
            </div>

            <div ref={criteriaContentRef} className={`schools-right ${isCriteriaContentVisible ? "animate-in" : ""}`}>
              {criteria?.description && (
                <p className="admissions-page-desc">{criteria.description}</p>
              )}

              {Array.isArray(rows) && rows.length > 0 && (
                <div className="admissions-page-table-wrapper">
                  <table className="admissions-page-table">
                    <thead>
                      <tr>
                        <th className="admissions-page-table-th">Class</th>
                        <th className="admissions-page-table-th">Age Group</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((row, index) => (
                        <tr key={index}>
                          <td className="admissions-page-table-td">{row.class_name}</td>
                          <td className="admissions-page-table-td">{row.age_group}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {criteria?.note_1 && (
                <p className="admissions-page-note">{criteria?.note_1}</p>
              )}

              {criteria?.note_2 && (
                <p className="admissions-page-note">{criteria?.note_2}</p>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Admission Application Procedure Section */}
      {procedure?.heading && (
        <div id="admission-application-procedurer" className="admissions-page-procedure-section">
          <div className="admissions-page-container">
            <div ref={procedureHeaderRef} className={`section-header ${isProcedureHeaderVisible ? "animate-in" : ""}`}>
              <h2 className="admissions-page-heading section-title-hm">{procedure?.heading}</h2>
            </div>

            <div ref={procedureContentRef} className={`schools-right ${isProcedureContentVisible ? "animate-in" : ""}`}>
              <p className="tigps-main-admission-procedure-p">{procedure?.intro_paragraph}</p>

              <div className="mv-wrapper">
                <div className="mv-box-admission">
                  <h4 className="admissions-page-box-title">{procedure?.manual_title}</h4>
                  <p className="tigps-main-admission-procedure-p">{procedure?.manual_content}</p>
                </div>

                <div className="mv-box-admission">
                  <h4 className="admissions-page-box-title">{procedure?.online_title}</h4>
                  <p className="tigps-main-admission-procedure-p">{procedure?.online_content}</p>
                </div>
              </div>


              {/* MENU / LISTS */}
              {Object.keys(groupedLists).length > 0 && (
                Object.keys(groupedLists).map((title, index) => (
                  <div key={index} className="admissions-page-list-box">
                    <h4 className="admissions-page-box-title">{title}</h4>

                    <ul className="admissions-page-list-ul">
                      {groupedLists[title].map((text, i) => (
                        <li
                          key={i}
                          className="admissions-page-list-li"
                        >
                          {text}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))
              )}


              <div className="admissions-page-withdrawal-banner">
                <h4 className="admissions-page-withdrawal-title">{procedure?.withdrawal_title}</h4>
                <p className="admissions-page-withdrawal-text">{procedure?.withdrawal_content}</p>
              </div>

              {procedure?.image && procedure.image.trim() !== "" && (
                <div className="admissions-page-image-wrapper">
                  <img
                    src={`${baseAPIUrl}assets/images/admission/${procedure.image}?t=${Date.now()}`}
                    alt="Admission Open"
                    className="admissions-page-image"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Application Form Section */}
      <AdmissionApplicationForm/>
    </div>
  );
};


// Styles are loaded from AdmissionsPage.css

export default AdmissionsPage;